export default __webpack_public_path__ + "resources/icons/n411-7807.png";